export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objectif de vente mensuel"])},
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])},
        "updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objectif de vente mis à jour"])}
      },
      "en": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monthly sales target"])},
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
        "updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales target updated"])}
      }
    }
  })
}
